import { CommonModule } from '@angular/common';
import {
  Component, computed, input, model, output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FieldState } from '../../../models/field.model';
import { InlineSvgComponent } from '../../inline-svg/inline-svg.component';

@Component({
  selector: 'ui-date-field',
  imports: [ CommonModule, FormsModule, InlineSvgComponent ],
  templateUrl: './date-field.component.html',
  styleUrl: './date-field.component.scss',
})
export class DateFieldComponent {
  /** Defines the style of the date field. */
  fieldState = FieldState;
  /** A unique name identifier for the date component.
   *  The name is a string generated with a random hexadecimal number.
  */
  name = input<string>(`ui-date-field-${(Math.round((Math.random() * 100000000)).toString(16))}`);
  /** Output bind value. */
  value = model<string | undefined>('');
  /** Defines the current style of the date field. */
  state = input<FieldState>(FieldState.Default);
  /** Alert text message to be displayed based on the value. */
  alert = input<string>();
  /** Defines if the text field is readonly. */
  disabled = input<boolean>(false);
  /**
   * Emits the current value when the field loses focus. Prefer this over `valueChange`
   * when a change is persisted: the native input emits on every segment edit, so typing
   * a year fires `0002-…`, `0020-…`, `0202-…` before the intended `2025-…`.
   */
  blurred = output<string | undefined>();
  /** Computed property that returns the icon
   * that should be displayed based on the FieldState.
  */
  icon = computed(() => {
    switch (this.state()) {
      case FieldState.Success:
      case FieldState.Info:
        return 'success';
      case FieldState.Invalid:
        return 'error';
      default:
        return '';
    }
  });
}
